import { mapToList } from "./utils";

export const EnumGoodsType = {
  A: 1, // 3C商品
};

export const GoodsTypeToTextMap = new Map([
  [EnumGoodsType.A, "3C商品"],
]);

export const GoodsTypeList = mapToList(GoodsTypeToTextMap);

export const EnumGoodsGroupCode = {
  MEMORY: "memory",
  COLOR: "color",
};

export const GoodsGroupCodeToTextMap = new Map([
  [EnumGoodsGroupCode.MEMORY, "内存"],
  [EnumGoodsGroupCode.COLOR, "颜色"],
]);

export const GoodsGroupCodeList = mapToList(GoodsGroupCodeToTextMap);

export const GoodsTypeToGoodsGroupCodeMap = new Map([
  [
    EnumGoodsType.A,
    [
      EnumGoodsGroupCode.MEMORY,
      EnumGoodsGroupCode.COLOR,
    ],
  ],
]);
